import React from 'react';
import PropTypes from 'prop-types';
import { ProfilePicture } from '@getro/rombo';
import { EmailButton } from '../emailButton';
import { Avatar, NameRow, NameText, Person, Pill, Subtitle } from '../../IntroPathCard.styles';

const PILL_LABEL = { you: 'You', team: 'Team', contact: 'Contact' };

export const PersonBlock = ({
  node,
  network,
  pillVariant,
  emails,
  emailFirstName,
  onContactClick,
  onEmailSelect,
  showProfileLink,
}) => {
  const name = node.avatarName;
  // "[position] at [company]" — degrade gracefully to whichever part exists.
  const subtitle = [node.currentJobTitle, node.currentCompany].filter(Boolean).join(' at ');
  const nameNode = showProfileLink ? (
    <NameText
      as="a"
      title={name}
      href={`/networks/${network.slug}/contacts/${node.id}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => onContactClick?.(node.id)}
    >
      {name}
    </NameText>
  ) : (
    <NameText title={name}>{name}</NameText>
  );

  return (
    <Person>
      <Avatar>
        <ProfilePicture name={node.avatarName} imageUrl={node.avatarUrl} size="32px" />
      </Avatar>
      <NameRow>
        {nameNode}
        {pillVariant && <Pill $variant={pillVariant}>{PILL_LABEL[pillVariant]}</Pill>}
      </NameRow>
      {subtitle && <Subtitle title={subtitle}>{subtitle}</Subtitle>}
      <EmailButton emails={emails} firstName={emailFirstName} onSelect={onEmailSelect} />
    </Person>
  );
};

PersonBlock.propTypes = {
  node: PropTypes.object.isRequired,
  network: PropTypes.shape({ slug: PropTypes.string.isRequired }).isRequired,
  pillVariant: PropTypes.oneOf(['you', 'team', 'contact']),
  emails: PropTypes.arrayOf(PropTypes.string),
  emailFirstName: PropTypes.string,
  onContactClick: PropTypes.func,
  onEmailSelect: PropTypes.func,
  showProfileLink: PropTypes.bool,
};

PersonBlock.defaultProps = {
  pillVariant: null,
  emails: undefined,
  emailFirstName: undefined,
  onContactClick: undefined,
  onEmailSelect: undefined,
  showProfileLink: true,
};
